import { useState, useCallback, useMemo } from "react";
import { FeaturesShowcaseModalContext } from "./FeaturesShowcaseModalContext";
import { FeaturesShowcaseModal } from "./FeaturesShowcaseModal";

export const FeaturesShowcaseModalProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [autoShowConfetti, setAutoShowConfetti] = useState(false);

  const open = useCallback((isAutoShowConfetti?: boolean) => {
    setAutoShowConfetti(!!isAutoShowConfetti);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setAutoShowConfetti(false);
    setIsOpen(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      open,
      close,
      isOpen,
      autoShowConfetti,
    }),
    [open, close, isOpen, autoShowConfetti]
  );

  return (
    <FeaturesShowcaseModalContext.Provider value={contextValue}>
      <FeaturesShowcaseModal />
      {children}
    </FeaturesShowcaseModalContext.Provider>
  );
};
